import { IUserEntryDate, IUserEntryDatesResponse } from './IUserEntryDates';
import { Injectable, Inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { IUserGroups } from './IUserGroups';

@Injectable({
    providedIn: 'root'
})
export class UserEntryDatesService {
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    private groupUri = `${environment.apiLocation}/UserGroup`;
    private uri = `${environment.apiLocation}/UserEntryDates`;

    public getUserGroups(): Observable<Array<IUserGroups>> {
        return this.http.get<Array<IUserGroups>>(this.groupUri).pipe(res => {
            this.log.verbose({
                type: 'UserentrydatesComponent:getUserGroups:reponse',
                res
            });
            return res;
        });
    }
    public getEntryDates(): Observable<Array<IUserEntryDate>> {
        return this.http.get<Array<IUserEntryDate>>(this.uri).pipe(res => {
            this.log.verbose({
                type: 'UserentrydatesComponent:getEntryDates:reponse',
                res
            });
            return res;
        });
    }
    public getEntryDatesByGroup(
        groups: Array<IUserGroups>
    ): Observable<Array<IUserEntryDate>> {
        return this.http
            .post<Array<IUserEntryDate>>(this.uri, groups)
            .pipe(res => {
                this.log.verbose({
                    type: 'UserentrydatesComponent:getEntryDatesByGroup:reponse',
                    res
                });
                return res;
            });
    }
    public putEntryDates(
        entryDates: Array<IUserEntryDate>
    ): Observable<IUserEntryDatesResponse> {
        this.log.debug({ type: 'GroupsService:putGroup', entryDates });
        this.log.verbose(JSON.stringify({ GroupMemberList: entryDates }));
        return this.http
            .put<IUserEntryDatesResponse>(this.uri, {
                UserEntryDates: entryDates
            })
            .pipe(res => {
                this.log.verbose({
                    type: 'GroupsService:putGroup:reponse',
                    res
                });
                return res;
            });
    }
}
